module.exports = {"id":"166940","name":"Alexandru Gaţcan","rating":"72","photo":"./data/images/photos/2/166940.png","club":{"name":"FK Rostov","logo":"./data/images/clubs/FKRostov.png"},"positions":["MC","MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexandruGatcan0.json
// module id = 262
// module chunks = 0